export default "__VITE_ASSET__DIOV_YaQ__"